import React from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANT from './../../constant';
import { getDateParts } from '../../utils';

class ComponentName extends React.Component<any, any>{
    render() {
        const { list } = this.props;
        return (
            <table className="tablen">
                <thead>
                    <tr className='text-center'>
                        <th scope="col" className="table-dark">Employee #</th>
                        <th scope="col" className="table-dark">Name</th>
                        <th scope="col" className="table-dark">Department</th>
                        <th scope="col" className="table-dark">Designation</th>
                        <th scope="col" className="table-dark">Unit</th>
                        <th scope="col" className="table-dark">Is HOD?</th>
                        <th scope="col" className="table-dark">Last updated</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list === undefined && <tr>
                            <td colSpan={7} className="text-center">Loading...</td>
                        </tr>
                    }
                    {
                        list !== undefined && list.length === 0 && <tr>
                            <td colSpan={7} className="text-center">No records found</td>
                        </tr>
                    }
                    {
                        list !== undefined && list.map((item: any) => {
                            const detailPageURL = CONSTANT.component.adminEditUser.url.replace(':code', item.code);
                            const dated = getDateParts(item.modifiedOn);
                            return (
                                <tr className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                    <td>{item.employeeNumber}</td>
                                    <td>{item.name}</td>
                                    <td>{item.departmentName}</td>
                                    <td>{item.designationName}</td>
                                    <td>{item.unitName}</td>
                                    <td>{item.isHOD ? <i className="fa fa-check-circle text-success" /> : <i className="fa fa-times-circle text-danger" />}</td>
                                    <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        )
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }
}

export default withRouter(ComponentName);